import ReducerRegistry from '../../../../../react/features/base/redux/ReducerRegistry';
import { TALK_RATE_ITEMS, TALK_RATES } from '../../../../components/hints/constants';

import {
    SET_HINTS
} from './actionTypes';

const DEFAULT_STATE = {
    enabled: false,
    enabledSoundHints: false,
    presetHints: TALK_RATE_ITEMS.find(i => i.slug === TALK_RATES.DEFAULT),
    data: {},
    currentUser: null
};


ReducerRegistry.register('wildix/features/hints', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    case SET_HINTS:
        return {
            ...state,
            ...action.value
        };
    }

    return state;
});
